import { Model } from "@/models/base/model";

export class Disease extends Model {
  constructor(params: any = {}) {
    super(params);
  }

  // 疾患一覧取得（ログインユーザに紐づく）
  async getUserDiseases(): Promise<any> {
    this.url = "/cms/api/users/diseases/list";
    return await super.fetch();
  }

  // 疾患一覧取得
  async getDiseases(cond: any): Promise<any> {
    const params = new URLSearchParams();

    if (cond.diseaseCodes?.length > 0) {
      params.append("diseaseCodes", cond.diseaseCodes.join(","));
    }

    const queryString = params.toString() ? "?" + params.toString() : "";
    this.url = `/cms/api/diseases/list${queryString}`;
    return await super.fetch();
  }

  // 疾患登録更新
  async updateUserDiseases(diseaseCode: string): Promise<any> {
    this.url = "/cms/api/users/diseases/update";
    return await this.save({ diseaseCode }, "POST");
  }
}
